import { put, select, takeEvery } from 'redux-saga/effects';

import {
  patientQuestionnaireInit,
  requestPatientQuestionnaireResponse,
} from 'store/actionCreators/patientQuestionnaireResponse';
import { getUserId } from 'store/selectors/user';
// import { createSagaRequestRace } from 'utilities/request';

export function* onPatientQuestionnaireInit() {
  const patientId = yield select(getUserId);
  yield put(requestPatientQuestionnaireResponse({ id: patientId }));

  // const { failure } = yield race(createSagaRequestRace(requestPatientQuestionnaireResponse));

  // if (failure) {
  //   return;
  // }
}

export default function*() {
  yield takeEvery(patientQuestionnaireInit, onPatientQuestionnaireInit);
}
